/**
 * Meno Aliv Wheel Component
 * Web Component para roleta de descontos
 */

(function () {
  // Evita registrar duas vezes se a section aparecer mais de uma vez
  if (window.__MENO_ALIV_WHEEL_DEFINED__) return;
  window.__MENO_ALIV_WHEEL_DEFINED__ = true;

  const STORAGE_KEYS = {
    PARTICIPATED: 'menoAlivWheelParticipated',
    DISMISSED: 'menoAlivWheelDismissed'
  };

  const SVG = {
    copy: () => '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>',
    check: () => '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20 6 9 17 4 12"/></svg>',
    spin: () => '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="8" width="18" height="4" rx="1"/><path d="M12 8v13"/><path d="M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7"/><path d="M7.5 8a2.5 2.5 0 0 1 0-5A4.8 8 0 0 1 12 8a4.8 8 0 0 1 4.5-5 2.5 2.5 0 0 1 0 5"/></svg>',
    star: (stroke = '#FF1C80') => `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="${stroke}" stroke-width="2"><path d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z"/></svg>`,
    close: () => '<svg viewBox="0 0 24 24" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>'
  };

  const TIMING = {
    SPIN_DURATION_MS: 4300,
    INITIAL_SPIN_DEG: 6 * 360,
    WHEEL_ANIM_START_DELAY_MS: 50,
    SPIN_REMAINING_MIN_MS: 500,
    ALREADY_PARTICIPATED_CLOSE_MS: 1800,
    COPY_BTN_RESET_MS: 2000,
    COPY_TOAST_DURATION_MS: 2500,
    CONFETTI_CLEANUP_MS: 4000
  };

  class MenoAlivWheel extends HTMLElement {
    constructor() {
      super();
      this.attachShadow({ mode: 'open' });
      
      this.config = this.getDefaultConfig();
      
      // Estado inicial
      this.state = {
        isOpen: false,
        step: 'initial', // initial, spinning, result
        phone: '',
        phoneError: '',
        prize: null,
        copied: false,
        spinAgainMode: false,
        spinAgainMessage: null,
        isLastResultRecall: false
      };
      
      this.currentRotation = 0;
      this.isSpinning = false;
      
      this.initializePrizes();
      
      this._autoOpenTimeoutId = null;
      this._wheelAnimTimeoutId = null;
      this._processResultTimeoutId = null;
      this._copyResetTimeoutId = null;
      this._copyToastTimeoutId = null;
      this._confettiCleanupTimeoutId = null;
      this._alreadyParticipatedCloseTimeoutId = null;
    }

    getDefaultConfig() {
      return {
        autoOpenSeconds: 5,
        targetUrl: '/checkout',
        socialProof: 'Mais de 2.500 mulheres já ganharam',
        spinEndpoint: '',
        couponNote: 'Cupom enviado também por WhatsApp',
        logoUrl: '',
        logoAlt: '',
        shopName: 'Shop',
        rootUrl: '/',
        cssUrl: '',
        shopDomain: '',
        blockedUtmSources: ['nextags', 'mailbiz']
      };
    }

    loadConfig() {
      const root = document.getElementById('meno-aliv-wheel-root');
      if (!root) return;
      const d = root.dataset;
      this.config = {
        ...this.config,
        autoOpenSeconds: Number(d.autoOpenSeconds ?? this.config.autoOpenSeconds),
        targetUrl: d.targetUrl ?? this.config.targetUrl,
        socialProof: d.socialProof ?? this.config.socialProof,
        spinEndpoint: d.spinEndpoint ?? this.config.spinEndpoint,
        couponNote: d.couponNote ?? this.config.couponNote,
        logoUrl: d.logoUrl ?? this.config.logoUrl,
        logoAlt: d.logoAlt ?? this.config.logoAlt,
        shopName: d.shopName ?? this.config.shopName,
        rootUrl: d.rootUrl ?? this.config.rootUrl,
        cssUrl: d.cssUrl ?? this.config.cssUrl,
        shopDomain: d.shopDomain ?? this.config.shopDomain,
        blockedUtmSources: this.parseBlockedUtmSources(d.blockedUtmSources)
      };
    }

    parseBlockedUtmSources(value) {
      if (!value || typeof value !== 'string') return this.config.blockedUtmSources ?? ['nextags', 'mailbiz'];
      return value.split(/[\s,]+/).map((s) => s.toLowerCase().trim()).filter(Boolean);
    }

    initializePrizes() {
      const WHEEL_A = '#FF1C80';
      const WHEEL_B = '#FFD0E2';
      
      this.prizes = [
        { id: '25', label: '25% OFF', color: WHEEL_A },
        { id: '10', label: '10% OFF', color: WHEEL_B },
        { id: 'GIFT', label: 'BRINDE<br>EXCLUSIVO', color: WHEEL_A },
        { id: '20', label: '20% OFF', color: WHEEL_B },
        { id: '10B', label: '10% OFF', color: WHEEL_A },
        { id: '15', label: '15% OFF', color: WHEEL_B },
        { id: 'AGAIN', label: 'GIRE<br>NOVAMENTE', color: WHEEL_A, isSpinAgain: true },
        { id: 'GIFT2', label: 'BRINDE<br>EXCLUSIVO', color: WHEEL_B }
      ];
      
      this.segmentIdToIndex = {};
      this.prizes.forEach((p, i) => { 
        this.segmentIdToIndex[p.id] = i; 
      });
    }

    connectedCallback() {
      this._mounted = true;
      this.loadConfig();
      this.render();
      this.checkAutoOpen();
      this.setupKeyboardHandlers();
      this.setupEventDelegation();
    }

    disconnectedCallback() {
      this._mounted = false;
      this.clearAllTimeouts();
      this.removeKeyboardHandlers();
      this.removeEventDelegation();
      this.unlockBodyScroll();
    }

    clearAllTimeouts() {
      [this._autoOpenTimeoutId, this._wheelAnimTimeoutId, this._processResultTimeoutId,
       this._copyResetTimeoutId, this._copyToastTimeoutId, this._confettiCleanupTimeoutId,
       this._alreadyParticipatedCloseTimeoutId].forEach((id) => {
        if (id != null) clearTimeout(id);
      });
      this._autoOpenTimeoutId = null;
      this._wheelAnimTimeoutId = null;
      this._processResultTimeoutId = null;
      this._copyResetTimeoutId = null;
      this._copyToastTimeoutId = null;
      this._confettiCleanupTimeoutId = null;
      this._alreadyParticipatedCloseTimeoutId = null;
    }

    setupKeyboardHandlers() {
      this._boundKeydown = (e) => {
        if (!this.state.isOpen) return;
        if (e.key === 'Escape') {
          const participated = this.state.step === 'result' || !!this.state.prize;
          this.closeModal(participated);
          return;
        }
        if (e.key === 'Tab') {
          if (!this.shadowRoot.contains(document.activeElement)) return;
          this.handleModalTab(e);
          return;
        }
      };
      
      this._boundFocusIn = (e) => {
        if (this.state.isOpen && this.shadowRoot.contains(e.target)) {
          this._lastFocusedInModal = e.target;
        }
      };
      
      document.addEventListener('keydown', this._boundKeydown);
      this.shadowRoot.addEventListener('focusin', this._boundFocusIn);
    }

    removeKeyboardHandlers() {
      document.removeEventListener('keydown', this._boundKeydown);
      if (this.shadowRoot) {
        this.shadowRoot.removeEventListener('focusin', this._boundFocusIn);
      }
    }

    setupEventDelegation() {
      if (this._boundDelegation) return;
      this._boundDelegation = (e) => {
        const target = e.target;
        const closeBtn = target.closest('.close-btn');
        if (closeBtn) {
          const participated = this.state.step === 'result' || !!this.state.prize;
          this.closeModal(participated);
          return;
        }
        const modal = target.closest('.meno-aliv-modal');
        if (modal && e.target === modal) {
          const participated = this.state.step === 'result' || !!this.state.prize;
          this.closeModal(participated);
          return;
        }
        const phoneInput = target.closest('#phone-input');
        if (phoneInput && e.type === 'input') {
          const formatted = this.formatPhone(e.target.value);
          this.state.phone = formatted;
          e.target.value = formatted;
          if (this.state.phoneError) {
            this.state.phoneError = '';
            this.updatePhoneErrorUI('');
          }
          return;
        }
        const wheelForm = target.closest('#wheel-form');
        if (wheelForm && e.type === 'submit') {
          e.preventDefault();
          this.handleSpin();
          return;
        }
        const copyBtn = target.closest('.copy-btn');
        if (copyBtn && e.type === 'click') {
          this.copyCode();
          return;
        }
        const ctaBtn = target.closest('.cta-btn');
        if (ctaBtn && e.type === 'click') {
          const prize = this.state.prize;
          if (prize?.code) {
            this.closeModal(true);
            const cartRoot = (typeof window.Shopify !== 'undefined' && window.Shopify.routes?.root)
              ? window.Shopify.routes.root
              : (this.config.rootUrl || '/');
            fetch(cartRoot + 'cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ discount: prize.code })
            }).catch(() => {});
          } else {
            this.closeModal(true);
            window.location.href = this.config.targetUrl;
          }
        }
      };
      this.shadowRoot.addEventListener('click', this._boundDelegation);
      this.shadowRoot.addEventListener('submit', this._boundDelegation);
      this.shadowRoot.addEventListener('input', this._boundDelegation);
    }

    removeEventDelegation() {
      if (!this._boundDelegation || !this.shadowRoot) return;
      this.shadowRoot.removeEventListener('click', this._boundDelegation);
      this.shadowRoot.removeEventListener('submit', this._boundDelegation);
      this.shadowRoot.removeEventListener('input', this._boundDelegation);
      this._boundDelegation = null;
    }

    // Gerenciamento de foco para acessibilidade
    getFocusableElements() {
      const container = this.shadowRoot.querySelector('.meno-aliv-content');
      if (!container) return [];
      
      const sel = 'button:not([disabled]), a[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
      return Array.from(container.querySelectorAll(sel)).filter((el) => {
        return el.offsetParent !== null && 
               !el.hasAttribute('disabled') && 
               (el.getAttribute('tabindex') !== '-1' || !el.hasAttribute('tabindex'));
      });
    }

    handleModalTab(e) {
      const focusables = this.getFocusableElements();
      if (focusables.length === 0) return;
      
      const focusInsideModal = document.activeElement === this || 
        (this._lastFocusedInModal && this.shadowRoot.contains(this._lastFocusedInModal));
      
      const current = focusInsideModal && 
        this._lastFocusedInModal && 
        focusables.includes(this._lastFocusedInModal)
          ? this._lastFocusedInModal
          : null;
      
      const idx = current !== null ? focusables.indexOf(current) : -1;
      let nextIdx;
      
      if (e.shiftKey) {
        nextIdx = idx <= 0 ? focusables.length - 1 : idx - 1;
      } else {
        nextIdx = idx >= focusables.length - 1 ? 0 : idx + 1;
      }
      
      e.preventDefault();
      focusables[nextIdx].focus();
      this._lastFocusedInModal = focusables[nextIdx];
    }

    focusFirstInModal() {
      requestAnimationFrame(() => {
        const focusables = this.getFocusableElements();
        if (focusables.length) focusables[0].focus();
      });
    }

    // Utilitários
    escapeHtml(str) {
      if (!str) return '';
      const div = document.createElement('div');
      div.textContent = str;
      return div.innerHTML;
    }

    sanitizeLabelAllowBr(str) {
      if (!str) return '';
      const escaped = this.escapeHtml(str.replace(/<br\s*\/?>/gi, '\n'));
      return escaped.replace(/\n/g, '<br>');
    }

    hexToRgb(hex) {
      const h = hex.replace('#','').trim();
      const full = h.length === 3 ? h.split('').map(c => c+c).join('') : h;
      const n = parseInt(full, 16);
      return { r: (n >> 16) & 255, g: (n >> 8) & 255, b: n & 255 };
    }

    getTextStyleForBg(hex) {
      const { r, g, b } = this.hexToRgb(hex);
      const yiq = (r*299 + g*587 + b*114) / 1000;
      const isLight = yiq >= 165;
      return isLight
        ? { color: '#2B2B2B', shadow: '0 1px 0 rgba(255,255,255,0.35)' }
        : { color: '#FFFFFF', shadow: '0 2px 4px rgba(0,0,0,0.45)' };
    }

    // Controle de scroll do body
    lockBodyScroll() {
      if (this._scrollLocked) return;
      this._scrollLocked = true;
      
      const scrollY = window.scrollY || document.documentElement.scrollTop || 0;
      this._lockedScrollY = scrollY;
      
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollY}px`;
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
    }

    unlockBodyScroll() {
      if (!this._scrollLocked) return;
      this._scrollLocked = false;
      
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      
      const y = this._lockedScrollY || 0;
      this._lockedScrollY = 0;
      window.scrollTo(0, y);
    }

    // Auto-abertura do modal
    checkAutoOpen() {
      if (!this.config.autoOpenSeconds) return;
      
      const utmSource = new URLSearchParams(location.search).get('utm_source');
      const blockedSources = this.config.blockedUtmSources || ['nextags', 'mailbiz'];
      if (utmSource && blockedSources.includes(utmSource.toLowerCase())) return;
      
      const hasParticipated = localStorage.getItem(STORAGE_KEYS.PARTICIPATED);
      const dismissed = localStorage.getItem(STORAGE_KEYS.DISMISSED);
      if (hasParticipated || dismissed) return;

      this._autoOpenTimeoutId = setTimeout(() => {
          this._autoOpenTimeoutId = null;
          this.state.isOpen = true;
          this.lockBodyScroll();
          this.render();
        }, this.config.autoOpenSeconds * 1000);
    }

    // Validação e formatação de telefone
    getNationalDigits(value) {
      let numbers = (value || '').replace(/\D/g, '');
      if (numbers.length > 11 && numbers.startsWith('55')) {
        numbers = numbers.slice(2);
      }
      return numbers.slice(0, 11);
    }

    formatPhone(value) {
      const numbers = this.getNationalDigits(value);
      if (!numbers.length) return '';
      return numbers
        .replace(/^(\d{2})(\d)/g, '($1) $2')
        .replace(/(\d{5})(\d)/, '$1-$2');
    }

    validatePhone() {
      if (this.state.spinAgainMode && this.state.phone) return true;
      
      const numbers = this.getNationalDigits(this.state.phone);
      if (numbers.length < 10) {
        this.state.phoneError = 'Por favor, insira um telefone válido';
        return false;
      }
      this.state.phoneError = '';
      return true;
    }

    updatePhoneErrorUI(message) {
      const phoneInput = this.shadowRoot.querySelector('#phone-input');
      if (!phoneInput) return;
      const formGroup = phoneInput.closest('.form-group');
      const existingError = formGroup?.querySelector('.error-text');
      
      if (message) {
        phoneInput.classList.add('error');
        phoneInput.setAttribute('aria-invalid', 'true');
        phoneInput.setAttribute('aria-describedby', 'phone-input-error');
        if (existingError) {
          existingError.textContent = message;
        } else {
          const errorEl = document.createElement('p');
          errorEl.id = 'phone-input-error';
          errorEl.className = 'error-text';
          errorEl.setAttribute('role', 'alert');
          errorEl.setAttribute('aria-live', 'polite');
          errorEl.textContent = message;
          formGroup?.appendChild(errorEl);
        }
      } else {
        phoneInput.classList.remove('error');
        phoneInput.removeAttribute('aria-invalid');
        phoneInput.removeAttribute('aria-describedby');
        existingError?.remove();
      }
    }

    getUtmParams() {
      const params = new URLSearchParams(location.search);
      const utm = {};
      if (params.get('utm_source')) utm.source = params.get('utm_source');
      if (params.get('utm_medium')) utm.medium = params.get('utm_medium');
      if (params.get('utm_campaign')) utm.campaign = params.get('utm_campaign');
      return Object.keys(utm).length ? utm : undefined;
    }

    // Lógica principal de girar a roleta
    async handleSpin() {
      if (this.isSpinning) return;

      if (!this.state.spinAgainMode) {
        const phoneInput = this.shadowRoot.querySelector('#phone-input');
        if (phoneInput) this.state.phone = (phoneInput.value || '').trim();
      }
      if (!this.validatePhone()) {
        this.updatePhoneErrorUI(this.state.phoneError);
        return;
      }
      
      if (!this.config.spinEndpoint) {
        this.state.phoneError = 'Endpoint da roleta não configurado.';
        this.render();
        return;
      }
      
      this.isSpinning = true;
      this.state.phoneError = '';
      
      this.state.step = 'spinning';
      this._spinStartTime = Date.now();
      this.render();
      
      this._wheelAnimTimeoutId = setTimeout(() => {
        this._wheelAnimTimeoutId = null;
        const wheel = this.shadowRoot.querySelector('.wheel-spin');
        if (wheel) {
          wheel.style.transition = `transform ${TIMING.SPIN_DURATION_MS}ms linear`;
          wheel.style.transform = `rotate(${TIMING.INITIAL_SPIN_DEG}deg)`;
        }
      }, TIMING.WHEEL_ANIM_START_DELAY_MS);
      
      // Requisição à API
      const payload = {
        phone: this.state.phone,
        shop: this.config.shopDomain,
        page: location.pathname || 'home'
      };
      
      const utm = this.getUtmParams();
      if (utm) payload.utm = utm;
      
      let res;
      try {
        res = await fetch(this.config.spinEndpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        });
      } catch (err) {
        this.handleSpinError('Falha na conexão. Tente novamente.');
        return;
      }
      
      if (!this._mounted) return;
      const body = await res.json().catch(() => ({}));
      if (!this._mounted) return;
      
      // Tratamento de respostas
      if (res.status === 409) {
        this.handleAlreadyParticipated(body);
        return;
      }
      
      if (res.status === 429) {
        this.handleSpinError(body.message || 'Muitas tentativas. Aguarde um minuto e tente novamente.');
        return;
      }
      
      if (res.status === 400) {
        this.handleBadRequest(body);
        return;
      }
      
      if (!res.ok) {
        this.handleSpinError('Algo deu errado. Tente novamente em instantes.');
        return;
      }
      
      this.processSpinResult(body);
    }

    handleSpinError(message) {
      if (!this._mounted) return;
      this.isSpinning = false;
      this.state.step = 'initial';
      this.state.phoneError = message;
      this.render();
    }

    handleAlreadyParticipated(body) {
      if (!this._mounted) return;
      this.isSpinning = false;
      if (body.lastResult && typeof body.lastResult === 'object') {
        this.state.prize = body.lastResult;
        this.state.step = 'result';
        this.state.isLastResultRecall = true;
        this.state.phoneError = '';
        this.render();
        return;
      }
      this.state.step = 'initial';
      this.state.phoneError = body.message || 'Você já participou da roleta.';
      this.render();
      this._alreadyParticipatedCloseTimeoutId = setTimeout(() => this.closeModal(true), TIMING.ALREADY_PARTICIPATED_CLOSE_MS);
    }

    handleBadRequest(body) {
      if (!this._mounted) return;
      this.isSpinning = false;
      this.state.step = 'initial';
      
      if (body.error === 'INVALID_PHONE') {
        this.state.phoneError = 'Telefone inválido.';
      } else if (body.error === 'INVALID_SHOP') {
        this.state.phoneError = 'Loja inválida.';
      } else if (body.error === 'SHOP_NOT_ALLOWED') {
        this.state.phoneError = body.message || 'Esta loja não está habilitada para a roleta.';
      } else {
        this.state.phoneError = body.message || 'Dados inválidos.';
      }
      this.render();
    }

    processSpinResult(body) {
      if (!this._mounted) return;
      const segmentId = body.ui?.segmentId;
      const index = segmentId != null ? this.segmentIdToIndex[segmentId] : undefined;
      
      if (index === undefined) {
        this.handleSpinError('Resposta inválida do servidor.');
        return;
      }
      
      const count = this.prizes.length;
      const segmentAngle = 360 / count;
      const segmentStart = index * segmentAngle;
      const offsetInSegment = segmentAngle * (0.2 + Math.random() * 0.6);
      const targetAngle = segmentStart + offsetInSegment;
      const extraSpins = 5;
      const finalRotation = (extraSpins * 360) + targetAngle;
      
      const elapsed = Date.now() - this._spinStartTime;
      const remainingMs = Math.max(TIMING.SPIN_DURATION_MS - elapsed, TIMING.SPIN_REMAINING_MIN_MS);
      const currentApprox = (elapsed / TIMING.SPIN_DURATION_MS) * TIMING.INITIAL_SPIN_DEG;
      const offsetInCircle = (((-finalRotation - currentApprox) % 360) + 360) % 360;
      const endAngle = currentApprox + 360 + offsetInCircle;
      
      const wheel = this.shadowRoot.querySelector('.wheel-spin');
      if (wheel) {
        wheel.style.transition = `transform ${remainingMs}ms cubic-bezier(0.33, 0.33, 0.2, 1)`;
        wheel.style.transform = `rotate(${endAngle}deg)`;
      }
      
      this._processResultTimeoutId = setTimeout(() => {
        this._processResultTimeoutId = null;
        if (!this._mounted) return;
        this.currentRotation = ((endAngle % 360) + 360) % 360;
        
        if (body.result?.type === 'SPIN_AGAIN') {
          this.handleSpinAgainResult();
          return;
        }
        
        this.handlePrizeWon(body.result);
      }, remainingMs);
    }

    handleSpinAgainResult() {
      if (!this._mounted) return;
      this.state.spinAgainMode = true;
      this.state.spinAgainMessage = '🎉 Sua sorte continua! Clique em "Girar novamente" e garanta seu prêmio 🍀';
      this.state.step = 'initial';
      this.isSpinning = false;
      this.render();
    }

    handlePrizeWon(result) {
      if (!this._mounted) return;
      this.state.prize = result;
      this.state.spinAgainMode = false;
      this.state.isLastResultRecall = false;
      this.state.step = 'result';
      localStorage.setItem(STORAGE_KEYS.PARTICIPATED, String(Date.now()));
      this.isSpinning = false;
      this.render();
      this.showConfettiAnimation();
    }

    showConfettiAnimation() {
      const confettiContainer = this.shadowRoot.querySelector('.confetti-container');
      if (!confettiContainer) return;
      
      const colors = ['#FF1C80', '#ffd700', '#FFD0E2', '#FF6BA8'];
      for (let i = 0; i < 50; i++) {
        const confetti = document.createElement('div');
        confetti.className = 'confetti';
        confetti.style.left = `${Math.random() * 100}%`;
        confetti.style.background = colors[Math.floor(Math.random() * colors.length)];
        confetti.style.animationDelay = `${Math.random() * 0.5}s`;
        confetti.style.animationDuration = `${2 + Math.random() * 2}s`;
        confettiContainer.appendChild(confetti);
      }
      
      this._confettiCleanupTimeoutId = setTimeout(() => {
        this._confettiCleanupTimeoutId = null;
        confettiContainer.innerHTML = '';
      }, TIMING.CONFETTI_CLEANUP_MS);
    }

    // Copiar código do cupom
    async copyCode() {
      if (!this.state.prize?.code) return;
      
      let ok = false;
      try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(this.state.prize.code);
          ok = true;
        }
      } catch (_) {}
      
      if (!ok) {
        const ta = document.createElement('textarea');
        ta.value = this.state.prize.code;
        ta.setAttribute('readonly', '');
        ta.style.cssText = 'position:fixed;left:-9999px;opacity:0;';
        document.body.appendChild(ta);
        ta.select();
        try {
          ok = document.execCommand('copy');
        } catch (_) {}
        document.body.removeChild(ta);
      }
      
      this.state.copied = true;
      this.showCopyToast(ok);
      
      const copyBtn = this.shadowRoot.querySelector('.copy-btn');
      if (copyBtn) {
        copyBtn.classList.add('copied');
        copyBtn.innerHTML = SVG.check();
      }
      
      clearTimeout(this._copyResetTimeoutId);
      this._copyResetTimeoutId = setTimeout(() => {
        this._copyResetTimeoutId = null;
        this.state.copied = false;
        const btn = this.shadowRoot?.querySelector('.copy-btn');
        if (btn) {
          btn.classList.remove('copied');
          btn.innerHTML = SVG.copy();
        }
      }, TIMING.COPY_BTN_RESET_MS);
    }

    showCopyToast(success) {
      const liveRegion = this.shadowRoot.querySelector('#copy-status-live');
      const toastEl = this.shadowRoot.querySelector('.copy-toast');
      const msg = success ? 'Copiado!' : 'Selecione e copie manualmente';
      
      if (liveRegion) {
        liveRegion.setAttribute('aria-live', 'polite');
        liveRegion.textContent = msg;
      }
      
      if (toastEl) {
        toastEl.textContent = msg;
        toastEl.style.display = 'block';
        clearTimeout(this._copyToastTimeoutId);
        this._copyToastTimeoutId = setTimeout(() => {
          this._copyToastTimeoutId = null;
          toastEl.style.display = 'none';
          if (liveRegion) liveRegion.textContent = '';
        }, TIMING.COPY_TOAST_DURATION_MS);
      }
    }

    closeModal(participated = false) {
      this.state.isOpen = false;
      this.unlockBodyScroll();
      if (participated) {
        localStorage.setItem(STORAGE_KEYS.PARTICIPATED, String(Date.now()));
      } else {
        localStorage.setItem(STORAGE_KEYS.DISMISSED, String(Date.now()));
      }
      this.render();
    }

    // Renderização
    getConicGradient() {
      const seg = 360 / this.prizes.length;
      return this.prizes
        .map((p, i) => `${p.color} ${i * seg}deg ${(i + 1) * seg}deg`)
        .join(', ');
    }

    renderWheel(bg) {
      const segmentAngle = 360 / this.prizes.length;
      const rotation = this.state.step === 'spinning' ? 0 : this.currentRotation;
      const wheelClass = this.state.step === 'spinning' ? 'wheel wheel-spin' : 'wheel';
      
      return `
        <div class="wheel-container">
          <div class="wheel-pointer"></div>
          <div class="wheel-wrap">
            <div
              class="${wheelClass}"
              style="
                background: conic-gradient(from -90deg, ${bg});
                transform: rotate(${rotation}deg);
              "
            >
              <div class="wheel-labels">
                ${this.prizes.map((prize, index) => {
                  const centerAngle = (segmentAngle * index) + (segmentAngle / 2);
                  const shouldFlip = centerAngle > 90 && centerAngle < 270;
                  const textRotation = shouldFlip ? centerAngle + 90 : centerAngle - 90;
                  const ts = this.getTextStyleForBg(prize.color);
                  const isAgain = prize.isSpinAgain;
                  const fontSize = isAgain ? '10px' : '11px';
                  const opacity = isAgain ? '0.9' : '1';
                  const label = this.sanitizeLabelAllowBr(prize.label);
                  return `
                    <div class="wheel-label" style="transform: rotate(${centerAngle}deg)">
                      <span style="
                        transform: translateX(-50%) rotate(${-centerAngle + textRotation}deg);
                        color: ${ts.color};
                        text-shadow: ${ts.shadow};
                        font-size: ${fontSize};
                        opacity: ${opacity};
                      ">${label}</span>
                    </div>
                  `;
                }).join('')}
              </div>
            </div>
          </div>
        </div>
      `;
    }

    renderInitialStep(bg) {
      const spinAgainMode = this.state.spinAgainMode;
      const subtitleText = spinAgainMode && this.state.spinAgainMessage
        ? this.state.spinAgainMessage
        : spinAgainMode ? 'Clique no botão abaixo para girar de novo.' : 'Todos os prêmios são garantidos! Gire agora e descubra o seu 🎁';
      const subtitleClass = spinAgainMode && this.state.spinAgainMessage ? 'subtitle subtitle--spin-again' : 'subtitle';
      
      return `
        <h2 class="title">${spinAgainMode ? 'Gire novamente!' : 'Ganhe até 25% OFF ou um brinde exclusivo!'}</h2>
        <p class="${subtitleClass}">${subtitleText}</p>
        
        ${this.renderWheel(bg)}
        
        <form id="wheel-form" novalidate>
          ${!spinAgainMode ? `
          <div class="form-group">
            <label class="label" for="phone-input">WhatsApp/Telefone *</label>
            <input
              type="tel"
              id="phone-input"
              class="input ${this.state.phoneError ? 'error' : ''}"
              placeholder="(00) 00000-0000"
              value="${this.escapeHtml(this.state.phone)}"
              maxlength="15"
              autocomplete="tel"
              aria-invalid="${!!this.state.phoneError}"
              aria-describedby="${this.state.phoneError ? 'phone-input-error' : ''}"
            />
            ${this.state.phoneError
              ? `<p id="phone-input-error" class="error-text" role="alert" aria-live="polite">${this.escapeHtml(this.state.phoneError)}</p>`
              : ''
            }
          </div>
          ` : spinAgainMode && this.state.phoneError ? `
          <p class="error-text" style="margin-bottom: 12px;">${this.escapeHtml(this.state.phoneError)}</p>
          ` : ''}
          
          <button type="submit" class="spin-btn">
            ${SVG.spin()}
            ${spinAgainMode ? 'Girar novamente' : 'Girar a Roleta'}
          </button>
        </form>
        
        <div class="social-proof">
          ${SVG.star()}
          ${this.config.socialProof}
        </div>
      `;
    }

    renderSpinningStep(bg) {
      return `
        <h2 class="title">Girando...</h2>
        <p class="subtitle">Preparando seu benefício...</p>
        ${this.renderWheel(bg)}
      `;
    }

    renderResultStep() {
      const prize = this.state.prize || {};
      const hasCode = prize.code;
      const ctaLabel = hasCode ? 'Aplicar cupom e continuar comprando' : 'Usar meu benefício';
      const isRecall = this.state.isLastResultRecall;
      const headline = isRecall
        ? 'Este foi seu resultado na última vez que você participou'
        : 'Parabéns! Você acaba de ganhar:';
      const codeLabel = isRecall 
        ? 'Use este código no checkout (seu cupom da vez):' 
        : 'Use este código no checkout:';
      
      return `
        <div class="result-container">
          <h2 class="congrats">${this.escapeHtml(headline)}</h2>
          <div class="prize-badge">${this.escapeHtml(prize.label || '')}</div>
          
          ${prize.description ? `
            <p class="prize-description">🎁 ${this.escapeHtml(prize.description)}</p>
          ` : ''}
          
          ${hasCode ? `
          <div class="code-container">
            <p class="code-label">${this.escapeHtml(codeLabel)}</p>
            <div class="code-value copy-toast-wrap">
              <span id="copy-status-live" class="sr-only" role="status" aria-live="polite" aria-atomic="true"></span>
              <span class="copy-toast" style="display:none;" aria-hidden="true">Copiado!</span>
              ${this.escapeHtml(prize.code)}
              <button class="copy-btn ${this.state.copied ? 'copied' : ''}" aria-label="Copiar cupom ${this.escapeHtml(prize.code)}">
                ${this.state.copied ? SVG.check() : SVG.copy()}
              </button>
            </div>
          </div>
          ` : ''}
          
          <p class="subtitle">${isRecall ? 'Seu cupom continua válido — aproveite na compra! ✨' : 'Seu desconto já está garantido! ✨'}</p>
          
          <button class="cta-btn">
            ${SVG.spin()}
            ${ctaLabel}
          </button>
          
          <div class="social-proof" style="margin-top: 24px;">
            ${SVG.star()}
            ${this.config.couponNote}
          </div>
        </div>
        <div class="confetti-container"></div>
      `;
    }

    render() {
      const bg = this.getConicGradient();
      
      const content =
        this.state.step === 'initial' ? this.renderInitialStep(bg) :
        this.state.step === 'spinning' ? this.renderSpinningStep(bg) :
        this.renderResultStep();
      
      const modalOpenClass = this.state.isOpen ? ' is-open' : '';
      const existingCssLink = this.shadowRoot.querySelector('link[rel="stylesheet"]');
      if (existingCssLink) existingCssLink.remove();
      this.shadowRoot.innerHTML = `
        <div class="meno-aliv-modal${modalOpenClass}" role="dialog" aria-modal="true" aria-label="Roleta de descontos" aria-hidden="${!this.state.isOpen}">
          <div class="meno-aliv-content">
            <div class="header">
              <div class="header__heading">
                ${this.config.logoUrl
                  ? `<div class="header__heading-logo-wrapper"><img class="header__heading-logo" src="${this.config.logoUrl}" alt="${this.escapeHtml(this.config.logoAlt)}" loading="lazy" /></div>`
                  : `<span class="header__heading-fallback">${this.escapeHtml(this.config.shopName)}</span>`
                }
              </div>
              <button type="button" class="close-btn" aria-label="Fechar">
                <span class="close-btn__icon">${SVG.close()}</span>
              </button>
            </div>
            <div class="body">${content}</div>
          </div>
        </div>
      `;
      
      if (this.config.cssUrl) {
        const cssLink = existingCssLink || document.createElement('link');
        cssLink.rel = 'stylesheet';
        cssLink.href = this.config.cssUrl;
        this.shadowRoot.prepend(cssLink);
      }
      
      if (this.state.isOpen) {
        this.lockBodyScroll();
        setTimeout(() => this.focusFirstInModal(), 0);
      } else {
        this.unlockBodyScroll();
      }
    }
  }

  // Registra o custom element
  customElements.define('meno-aliv-wheel', MenoAlivWheel);

  // Adiciona o componente ao DOM se ainda não existir
  if (!document.querySelector('meno-aliv-wheel')) {
    document.body.insertAdjacentHTML('beforeend', '<meno-aliv-wheel></meno-aliv-wheel>');
  }
})();
